import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {setMessage} from './message';

import nalcoRateService from '../services/nalco-rate.service';


export const fetchNalcoRateList = createAsyncThunk(
    'nalcoRate/fetchNalcoRateList',
    async ({page, pagesize, search, groupId, ordering}, thunkAPI) => {
        try {
            const response = await nalcoRateService.getNalcoRateList(page, pagesize, search, groupId, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchNalcoRateForQuotation = createAsyncThunk(
    'nalcoRate/fetchNalcoRateForQuotation',
    async (_, thunkAPI) => {
        try {
            const response = await nalcoRateService.getNalcoRateQuotation();
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchArchivedNalcoRateList = createAsyncThunk(
    'nalcoRate/fetchArchivedNalcoRateList',
    async ({page, pagesize, search, ordering}, thunkAPI) => {
        try {
            const response = await nalcoRateService.getNalcoRateArchiveList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchNalcoRateById = createAsyncThunk(
    'nalcoRate/fetchNalcoRateById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await nalcoRateService.getNalcoRateById(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const createNalcoRate = createAsyncThunk(
    'nalcoRate/createNalcoRate',
    async (values , thunkAPI) => {
        try {            
            const response = await nalcoRateService.addNalcoRate(values);
            return response.data;
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updateNalco = createAsyncThunk(
    'nalcoRate/updateNalco',
    async ({ id, values}, thunkAPI) => {
        try {
            const response = await nalcoRateService.updateNalcoRate(id, values);
            return response.data; // Return the updated die group data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteNalcoRate = createAsyncThunk(
    'nalcoRate/deleteNalcoRate',
    async (id, thunkAPI) => {
        try {
            await nalcoRateService.deleteNalcoRate(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const unArchiveNalcoRate = createAsyncThunk(
    'nalcoRate/unArchiveNalcoRate',
    async (id, thunkAPI) => {
        try {
            await nalcoRateService.unArchiveNalcoRate(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    nalcoRateData: null,
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    loading: false,
    hasMore: true,
};


const nalcoRateSlice = createSlice({
    name: 'nalcoRate',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetNalcoRateData: (state) => {
            state.data = []; // This will clear the list
        },
        reserLatestNalcoRateData: (state) => {
            state.nalcoRateData = null; // This will clear the list
        },
        resetNalcoRateList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentNalcoRatePage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchNalcoRateList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchNalcoRateList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchNalcoRateList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });
            builder
            .addCase(fetchNalcoRateForQuotation.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchNalcoRateForQuotation.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.nalcoRateData = action.payload.data || null;  // Update to match your API response
            })
            .addCase(fetchNalcoRateForQuotation.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });
        builder
            .addCase(fetchArchivedNalcoRateList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedNalcoRateList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedNalcoRateList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });
        builder
            .addCase(fetchNalcoRateById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNalcoRateById.fulfilled, (state, action) => {
                state.loading = false;
                state.activeProfileRecord = action.payload;
            })
            .addCase(fetchNalcoRateById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(createNalcoRate.pending, state => {
                state.status = 'loading';
            })
            .addCase(createNalcoRate.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createNalcoRate.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
        builder
            .addCase(updateNalco.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateNalco.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const updateDieProfile = action.payload;
                const index = state.data.findIndex(group => group.id === updateDieProfile.id); // Find the index of the updated group
                if (index !== -1) {
                    state.data[index] = updateDieProfile; // Replace the old group with the updated one
                }
            })
            .addCase(updateNalco.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteNalcoRate.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteNalcoRate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteNalcoRate.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveNalcoRate.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveNalcoRate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveNalcoRate.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetNalcoRateData, reserLatestNalcoRateData, resetNalcoRateList, resetCurrentNalcoRatePage } = nalcoRateSlice.actions;
export default nalcoRateSlice.reducer;
